import React from "react";
import validator from "validator";
import { injectIntl } from "react-intl";
import { formatDate } from "../player/utils/utils";
import { C } from "../player/utils/ms-access-code";
import MsPanelButton from "./ms-panel-button.jsx";
import MSStreamLoader from "./ms-stream-loader.jsx";
import MsField from "./ms-field.jsx";
import MSStreamPurchase from "./ms-stream-purchase.jsx";

class MSStreamRegistration extends React.PureComponent {
    constructor(props) {
        super(props);
        let timeDiff = this.props.goLive * 1000 - Date.now();
        this.wcData = this.props.wcdata
            ? this.props.wcdata.split("--")
            : "0--0--0";
        this.checkAccessCode = timeDiff <= 36 * 60 * 60 * 1000;
        this.prodData = {
            cur: this.wcData[0],
            price: Number(this.wcData[1]).toFixed(2),
            tax: this.wcData[2],
            title: this.props.streamName,
        };
        this.dateGoLive = formatDate(this.props.goLive);
        this.restMS = this.props.restMS;
        this.accessHandler = null;
        this.state = {
            showPanel: false,
            notRunning: true,
            screen: "initial",
            accessCode: "",
            accessCodeError: false,
            firstName: "",
            firstNameError: false,
            lastName: "",
            lastNameError: false,
            email: "",
            errorMessage: "",
            emailError: false,
            emailSent: false,
            newAccess: false,
            purchaseScreen: false,
        };
        this.checkStreamData = this.checkStreamData.bind(this);
        this.checkStreamRunning = this.checkStreamRunning.bind(this);
        this.displayModal = this.displayModal.bind(this);
        this.goInitial = this.goInitial.bind(this);
        this.showGetCode = this.showGetCode.bind(this);
        this.showEnterCode = this.showEnterCode.bind(this);
        this.displayInitial = this.displayInitial.bind(this);
        this.displayGetCode = this.displayGetCode.bind(this);
        this.displayEnterCode = this.displayEnterCode.bind(this);
        this.setAccessCode = this.setAccessCode.bind(this);
        this.setFirstName = this.setFirstName.bind(this);
        this.setLastName = this.setLastName.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.submitCode = this.submitCode.bind(this);
        this.checkCode = this.checkCode.bind(this);
        this.displayOrderCompleted = this.displayOrderCompleted.bind(this);
        this.showLostPassword = this.showLostPassword.bind(this);
        this.displayLostPassword = this.displayLostPassword.bind(this);
        this.lostAccess = this.lostAccess.bind(this);
        this.showPurchase = this.showPurchase.bind(this);
        this.goToExternalLink = this.goToExternalLink.bind(this);
        this.viewStream = this.viewStream.bind(this);
        this.hideStream = this.hideStream.bind(this);
    }

    componentDidMount() {
        this.setState({ emailSent: false });

        if (!this.state.showPanel) {
            if (this.checkAccessCode) {
                this.checkStreamData(
                    (isRunning) => {
                        this.displayModal(isRunning);
                    },
                    (isRunning) => {
                        this.checkStreamRunning();
                        this.displayModal(isRunning);
                    },
                );
            } else {
                this.checkStreamRunning();
                this.displayModal();
            }
        }
    }

    checkStreamData(callback, error) {
        this.restMS.getStreamData(
            (resp) => {
                resp.data.t = resp.key;
                this.accessHandler = new C(resp.data);
                this.accessHandler.setCallback(() => {
                    this.viewStream();
                });
                this.accessHandler.setStopCallback(() => {
                    this.hideStream();
                });
                callback(true);
            },
            (err) => {
                console.log("ERROR >>", err);
                error(false);
            },
        );
    }

    checkStreamRunning() {
        this.restMS.pingStream(
            (resp) => {
                if (resp) {
                    // console.log('----> pingStream', resp);
                    this.checkStreamData(
                        (isRunning) => {
                            this.setState({
                                showPanel: true,
                                notRunning: !isRunning,
                            });
                        },
                        (isRunning) => {
                            // console.log('Error in request data --->', isRunning);
                            this.setState({
                                showPanel: true,
                                notRunning: !isRunning,
                            });
                        },
                    );
                } else {
                    setTimeout(() => {
                        this.checkStreamRunning();
                    }, 3000);
                }
            },
            (err) => {
                console.error("ERROR >>", err);
            },
        );
    }

    //here check for querystring
    async displayModal(isRunning = false, extraData = {}) {
        if (this.accessHandler) {
            let validCookie = await this.accessHandler.checkCookie();
            console.log(" cookie", validCookie);
            if (validCookie) {
                return;
            }
            let validQueryString =
                await this.accessHandler.checkQueryString("ac");
            if (validQueryString) {
                return;
            }
        }
        this.setState({ showPanel: true, notRunning: !isRunning });
    }

    goInitial() {
        this.setState({
            accessCode: "",
            accessCodeError: false,
            firstName: "",
            firstNameError: false,
            lastName: "",
            lastNameError: false,
            email: "",
            emailError: false,
            errorMessage: "",
            screen: "initial",
            newAccess: false,
            purchaseScreen: false,
        });
    }

    showPurchase() {
        this.setState({ purchaseScreen: true });
    }

    goToExternalLink(external_link) {
        window.open(external_link, "_blank");
    }

    showGetCode() {
        this.setState({ screen: "get-code" });
    }

    showEnterCode() {
        this.setState({ screen: "enter-code" });
    }

    showLostPassword() {
        this.setState({ screen: "lost-password" });
    }

    setAccessCode(newAccessCode) {
        this.setState({ accessCode: newAccessCode });
    }

    setFirstName(newFirstName) {
        this.setState({ firstName: newFirstName });
    }

    setLastName(newLastName) {
        this.setState({ lastName: newLastName });
    }

    setEmail(newEmail) {
        this.setState({ email: newEmail });
    }

    submitCode() {
        let firstNameError = this.state.firstName == "";
        let lastNameError = this.state.lastName == "";
        let emailError =
            this.state.email == "" || !validator.isEmail(this.state.email);
        this.setState({
            firstNameError: firstNameError,
            lastNameError: lastNameError,
            emailError: emailError,
        });
        if (!firstNameError && !lastNameError && !emailError) {
            this.setState({
                showPanel: false,
            });
            this.restMS.restRequest(
                "gac",
                {
                    auth: {
                        billing: {
                            first_name: this.state.firstName,
                            last_name: this.state.lastName,
                            email: this.state.email,
                        },
                        cout: this.prodData.cout,
                    },
                },
                (resp) => {
                    console.log("----->", resp);
                    if (!resp.success) {
                        this.setState({
                            showPanel: true,
                            errorMessage: resp.data,
                        });
                        return;
                    }
                    this.setState({
                        showPanel: true,
                        screen: "order-completed",
                        newAccess: resp.data.type == "created",
                    });
                },
                (err) => {
                    this.setState({
                        showPanel: true,
                        errorMessage: "Error during request.",
                    });
                },
            );
        } else {
            if (!validator.isEmail(this.state.email)) {
                this.setState({
                    errorMessage: "Invalid Email",
                });
            } else {
                this.setState({
                    errorMessage: "Missing Data",
                });
            }
        }
    }

    async checkCode() {
        // remove cookie if exists
        try {
            await this.accessHandler.removeStreamCookie();
        } catch (e) {
            console.error("Failed to delete the cookie");
        }

        console.log("-----> HERE");
        this.setState({
            showPanel: false,
            accessCodeError: false,
            errorMessage: "",
        });

        if (this.accessHandler == null) {
            this.setState({
                showPanel: true,
                accessCodeError: true,
                errorMessage: "Something went wrong.",
            });
            return;
        }

        if (this.state.accessCode == "") {
            this.setState({
                showPanel: true,
                accessCodeError: true,
                errorMessage: "Access Code required.",
            });
            return;
        }

        console.log("----------> validate access code", this.state.accessCode);
        let validated = await this.accessHandler.validate(
            this.state.accessCode,
        );

        if (!validated) {
            this.setState({
                showPanel: true,
                accessCodeError: true,
                errorMessage: "Access Code invalid.",
            });
            return;
        }

        await this.accessHandler.placeStreamCookie(this.state.accessCode);
    }

    lostAccess() {
        this.setState({
            showPanel: false,
            emailError: false,
            errorMessage: "",
        });

        if (this.state.email == "") {
            this.setState({
                showPanel: true,
                emailError: true,
                errorMessage: "Missing Data",
            });
            return false;
        }
        if (!validator.isEmail(this.state.email)) {
            this.setState({
                showPanel: true,
                emailError: true,
                errorMessage: "Invalid Email",
            });
            return false;
        }

        console.log("sending email ---->>>");

        this.restMS.restRequest(
            "lac",
            {
                email: this.state.email,
            },
            (resp) => {
                console.log(resp);
                if (!resp.success) {
                    this.setState({
                        showPanel: true,
                        emailError: true,
                        errorMessage: resp.data,
                        emailSendt: false, // added-mra
                    });
                } else {
                    this.setState({
                        showPanel: true,
                        emailError: false,
                        errorMessage: "",
                        emailSent: true,
                    });
                }
            },
            (err) => {
                console.log(err);
                console.log("Error12");
                this.setState({
                    showPanel: true,
                    emailError: true,
                    errorMessage: "Request not concluded.",
                });
            },
        );
    }

    displayInitial() {
        const goLiveStyle = {
            textSlign: "center",
            fontSize: "12px",
            width: "100%",
            float: "left",
        };

        let infoMessage = this.props.isEcommerce ? (
            <>
                buy it for{" "}
                <b>
                    {this.prodData.cur} ${this.prodData.price}
                </b>{" "}
                clicking on 'Purchase Access Code'.
            </>
        ) : (
            <>get a new one clicking on 'Get Access Code'.</>
        );
        let info = this.checkAccessCode ? (
            <>
                <p>This stream requires access code.</p>
                <p>
                    You can enter with your access code clicking on 'Enter
                    Access Code' or {infoMessage}
                </p>
            </>
        ) : (
            <>
                <p>
                    This stream requires access code but is currently
                    unavailable for view.
                </p>
                <p>If you do not have access code yet you can {infoMessage}</p>
            </>
        );
        let buttonLeft =
            this.props.externally_managed &&
                this.props.external_access_code_page &&
                this.props.isEcommerce ? (
                <MsPanelButton
                    id="goto-external-acc-link"
                    label="Purchase Access Code"
                    onClickEvent={() => {
                        this.goToExternalLink(
                            this.props.external_access_code_page,
                        );
                    }}
                    classes="btn-primary alt"
                    payload="data-opt='goto-external'"
                />
            ) : this.props.externally_managed &&
                this.props.external_access_code_page ? (
                <MsPanelButton
                    id="goto-external-acc-link"
                    label="Get Access Code"
                    onClickEvent={() => {
                        this.goToExternalLink(
                            this.props.external_access_code_page,
                        );
                    }}
                    classes="btn-primary alt"
                    payload="data-opt='goto-external'"
                />
            ) : this.props.isEcommerce ? (
                <MsPanelButton
                    id="purchase-acc-submit"
                    label="Purchase Access Code"
                    onClickEvent={this.showPurchase}
                    classes="btn-primary alt"
                    payload="data-opt='purchase-access'"
                />
            ) : (
                <MsPanelButton
                    id="get-acc-submit"
                    label="Get Access Code"
                    onClickEvent={this.showGetCode}
                    classes="btn-primary alt"
                    payload="data-opt='get-access'"
                />
            );

        let message = !this.checkAccessCode
            ? "Stream available 36 hours before go-live date"
            : "Stream not available yet";
        let buttonRight = !this.state.notRunning ? (
            <MsPanelButton
                id="enter-acc-submit"
                onClickEvent={this.showEnterCode}
                label="Enter Access Code"
                classes="btn-primary alt"
                payload="data-opt='enter-access'"
            />
        ) : (
            <>
                <MsPanelButton
                    id="enter-acc-submit"
                    label="Enter Access Code"
                    classes="btn-primary alt alt disabled"
                    payload="data-opt='enter-access' disabled='disabled'"
                />
                <div
                    className="ui icon mark-question"
                    data-inverted=""
                    data-tooltip={message}
                    data-position="top center"
                >
                    <i className="question circle icon"></i>
                </div>
            </>
        );
        return (
            <>
                <p className="subtitle sm-text bold">
                    Scheduled to go-live: {this.dateGoLive}
                </p>
                <div className="information_place">{info}</div>
                <div className="enter_access_buttons">
                    <div className="left_buttons">{buttonLeft}</div>
                    <div className="right_buttons">{buttonRight}</div>
                </div>
            </>
        );
    }

    displayEnterCode() {
        let buttonLeft = (
            <MsPanelButton
                id="access-code-back"
                label="Back"
                onClickEvent={this.goInitial}
                classes="btn-primary alt"
                payload=""
            />
        );
        let buttonRight = (
            <MsPanelButton
                id="access-code-submit"
                label="Submit"
                onClickEvent={this.checkCode}
                classes="btn-primary alt"
                payload=""
            />
        );
        return (
            <>
                <p className="subtitle">Enter your Access Code</p>
                {this.state.errorMessage ? (
                    <div
                        id="payment-error"
                        style={{
                            padding: 10,
                            boxSizing: "border-box",
                            backgroundColor: "antiquewhite",
                            borderRadius: "2.5px",
                        }}
                        className="error-notification"
                    >
                        {this.state.errorMessage}
                    </div>
                ) : null}
                <form className="form_access_code">
                    <MsField
                        id="access-code-input"
                        label="Access Code"
                        classes=""
                        value={this.state.accessCode}
                        onChange={this.setAccessCode}
                        showError={this.state.accessCodeError}
                    />
                </form>
                <p className="lost_password">
                    <a
                        id="lost-access-code"
                        onClick={this.showLostPassword}
                        href="#"
                    >
                        Lost access code?
                    </a>
                </p>
                <div className="enter_access_buttons">
                    <div className="left_buttons">{buttonLeft}</div>
                    <div className="right_buttons">{buttonRight}</div>
                </div>
            </>
        );
    }

    displayGetCode() {
        let buttonLeft = (
            <MsPanelButton
                id="access-code-back"
                label="Back"
                onClickEvent={this.goInitial}
                classes="btn-primary alt"
                payload=""
            />
        );
        let buttonRight = (
            <MsPanelButton
                id="access-code-get"
                label="Submit"
                onClickEvent={this.submitCode}
                classes="btn-primary alt"
                payload=""
            />
        );
        return (
            <>
                <div>
                    <p className="subtitle">Get Access Code</p>
                </div>
                {this.state.errorMessage ? (
                    <div
                        id="payment-error"
                        style={{
                            padding: 10,
                            boxSizing: "border-box",
                            backgroundColor: "antiquewhite",
                            borderRadius: "2.5px",
                        }}
                        className="error-notification"
                    >
                        {this.state.errorMessage}
                    </div>
                ) : null}
                <form className="form_access_code">
                    <MsField
                        id="first_name"
                        label="First Name"
                        classes=""
                        value={this.state.firstName}
                        onChange={this.setFirstName}
                        showError={this.state.firstNameError}
                    />
                    <MsField
                        id="last_name"
                        label="Last Name"
                        classes=""
                        value={this.state.lastName}
                        onChange={this.setLastName}
                        showError={this.state.lastNameError}
                    />
                    <MsField
                        id="email"
                        label="Email Address"
                        classes=""
                        value={this.state.email}
                        onChange={this.setEmail}
                        showError={this.state.emailError}
                    />
                </form>
                <div className="enter_access_buttons">
                    <div className="left_buttons">{buttonLeft}</div>
                    <div className="right_buttons">{buttonRight}</div>
                </div>
            </>
        );
    }

    displayOrderCompleted() {
        const titleStyle = {
            fontSize: "20px",
            margin: "10px",
        };
        let createdMsg = this.state.newAccess
            ? "Thank you"
            : "Email already registered";
        return (
            <div className="order-completed">
                <h1 style={titleStyle}>
                    {createdMsg}. Your access code has been sent to your email.
                </h1>
                <div className="access_code_wrapper">
                    <p>Your email:</p>
                    <h2>
                        <code>{this.state.email}</code>
                    </h2>
                    <p>
                        {this.checkAccessCode ? (
                            <>
                                To watch the stream click on
                                the button below and enter your{" "}
                                <i>Access Code.</i>
                            </>
                        ) : (
                            <></>
                        )}
                    </p>
                    <MsPanelButton
                        id="access-code-back"
                        label="Back"
                        onClickEvent={this.goInitial}
                        classes="btn-primary alt"
                        payload=""
                    />
                </div>
            </div>
        );
    }

    displayLostPassword() {
        let btnStyle = {
            position: "relative",
        };

        return (
            <div className="embv_login_wrapper">
                <div className="stream_title">
                    <h1>Lost Access Code</h1>
                </div>
                <div className="stream_body">
                    {this.state.emailSent ? (
                        <>
                            <p
                                style={{
                                    padding: 10,
                                    boxSizing: "border-box",
                                    backgroundColor: "aliceblue",
                                    borderRadius: "2.5px",
                                }}
                                className="subtitle"
                            >
                                Access code sent please check your email. If you
                                don’t receive a message in 5 minutes, check the
                                junk folder.
                            </p>
                        </>
                    ) : null}

                    {this.state.errorMessage ? (
                        <div
                            id="access-error"
                            style={{
                                padding: 10,
                                boxSizing: "border-box",
                                backgroundColor: "antiquewhite",
                                borderRadius: "2.5px",
                            }}
                            className="error-notification"
                        >
                            {this.state.errorMessage}
                        </div>
                    ) : null}

                    <form id="lost-access-code-form" method="post">
                        <p className="subtitle">
                            Please enter your email address then we can send
                            your access code to your email.
                        </p>
                        <div className="fields_wrapper">
                            <MsField
                                id="email"
                                label="Email Address"
                                classes=""
                                value={this.state.email}
                                onChange={this.setEmail}
                                showError={this.state.emailError}
                                style={{ "padding-bottom": "10px" }}
                            />
                        </div>
                        <div className="singup_buttons">
                            <div className="leftFloat" style={btnStyle}>
                                <MsPanelButton
                                    id="access-code-back"
                                    label="Back"
                                    onClickEvent={this.goInitial}
                                    classes="btn-primary alt"
                                    payload=""
                                />
                            </div>
                            <div className="rightFloat" style={btnStyle}>
                                {!this.state.emailSent ? (
                                    <MsPanelButton
                                        id="lost-access-submit"
                                        label="Submit"
                                        onClickEvent={this.lostAccess}
                                        classes="btn-primary alt"
                                        payload=""
                                    />
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    viewStream() {
        this.setState({ showPanel: false });
        this.props.loadPlayer();
    }

    hideStream() {
        this.props.hidePlayer();
    }

    render() {
        if (!this.state.showPanel) {
            return (
                <MSStreamLoader
                    divId="player_container_emb"
                    width="100%"
                    height="100%"
                />
            );
        }

        if (this.state.purchaseScreen) {
            return (
                <MSStreamPurchase
                    prodData={this.prodData}
                    streamName={this.props.streamName}
                    backScreen={this.goInitial}
                    successScreen={this.viewStream}
                    wcdata={this.wcData}
                    userData={{}}
                    restMS={this.props.restMS}
                    token={false}
                />
            );
        }

        let component = null;
        switch (this.state.screen) {
            case "enter-code":
                component = this.displayEnterCode();
                break;
            case "get-code":
                component = this.displayGetCode();
                break;
            case "order-completed":
                component = this.displayOrderCompleted();
                break;
            default:
                component = this.displayInitial();
        }

        return (
            <div className="wpstream_access_code_backgorund">
                {this.state.screen == "lost-password" ? (
                    this.displayLostPassword()
                ) : (
                    <div className="embv_access_code_wrapper">
                        <div className="stream_title">
                            <h1>{this.props.streamName}</h1>
                        </div>
                        <div className="stream_body" id="access_code_container">
                            {component}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
export default injectIntl(MSStreamRegistration);
